import { Component, Input } from '@angular/core';
import { TableDescription } from '@mwe/models';
import { NgClass } from '@angular/common';
import { InfoTextComponent } from '../info-text/info-text.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'mwe-table-striped',
  templateUrl: './table-striped.component.html',
  imports: [NgClass, InfoTextComponent, TranslatePipe],
})
export class TableStripedComponent {
  @Input() description: TableDescription;
  @Input() cellClasses: string[] = [];
  @Input() classes: string[] = [];
}
